export const defaultReconnectChatPaneContinueChatButtonHoveredStyles = {
  filter: "brightness(0.8)"
};